// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.food_sensory_pacing */
var FoodSensoryPacing;
(function (FoodSensoryPacing) {
    FoodSensoryPacing["hosted"] = "hosted";
    FoodSensoryPacing["self_paced"] = "self_paced";
})(FoodSensoryPacing || (FoodSensoryPacing = {}));
;
export default FoodSensoryPacing;
/** Zod schema for food_sensory_pacing */
export const foodSensoryPacing = z.nativeEnum(FoodSensoryPacing);
//# sourceMappingURL=FoodSensoryPacing.js.map